<template>
  <DBox
    :id="'cmp-distribution-accounts-account_sidewindow-catalogue_labels_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('label')}`"
    @addClick="onAddClick"
  >
    <NTable
      :id="'distribution-accounts-account_sidewindow-catalogue_labels_list'"
      class="catalogue_labels_list h2 p0 dbox1"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('labels')">
            <span class="txtov" :title="item['label_name']">
              {{ item["label_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('release_shift')">
            <TextField2
              :ta="'right'"
              :id="'release_shift'"
              :showLabel="false"
              :disabled="item['disabled']"
              :value="item['release_shift']"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('exclude_for_account')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="`${item['exclude']}`"
                  :id="`${item['exclude']}`"
                  :checked="item['exclude'] == '1'"
                  @click="e => onCheckBox(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>

          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteCatalogueLabel(item)"
              class="dt-icon v5 s2 ut-center"
              alt="Delete supplier"
              title="Delete supplier"
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import Dropdown from "../../../../plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import TextInput from "../../../../plugins/text-field/text-input";
import {
  createModalMixin,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import AddCatalogueLabel from "./add-label";
import { AccountService } from "../../services/account.service";
import { async } from "rxjs/internal/scheduler/async";
import { confirmDelete,confirmDeleteWithMessege } from "../../../../dt-plugins/confirmation/confirmation-common";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionAccountActions } from "../../store/accounts/actions";
export default {
  components: {
    NTable,
    TextInput,
    AddCatalogueLabel
  },
  props: ["selectedAccountsDetails"],
  data: function() {
    return {
      selectedInvoice: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false
      }),
      addCatalogueLabelModalContainer: false
    };
  },

  computed: {
    list: function() {
      return this.selectedAccountsDetails.label_accounts || [];
    },
    headers: function() {
      return [
        createTableHeader("labels"),
        createTableHeader("release_shift", { ta: "center", mw: 100 }),
        createTableHeader("exclude_for_account", { mw: 150 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    ...mapActionObject(storeNS, distributionAccountActions),
    onAddClick: function() {
      this.$emit("add_click", "add_label_form");
    },

    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.label_account_id,
        table: "l_label_accounts"
      });
      this.updateData(item);
    },
    onCatalogueLabelAdded: function(catalogueLabels) {
      this[ActionTypes.CATALOGUE_LABELS.SET.ALL](catalogueLabels);
      this.onAddCatalogueLabelCancelled();
    },
    onDeleteCatalogueLabel: async function(item) {
      const confirmationResult = await confirmDeleteWithMessege(this.$t('delete_label_account_msg'));
      if (confirmationResult === "OK") {
        const res = await AccountService.deleteLabelAccount({ ...item });
        const label_accounts = this.selectedAccountsDetails.label_accounts.filter(
          b => b.label_account_id !== item.label_account_id
        );
        this[ActionTypes.DistributionCatalogueLabels.SET.ALL]({
          account_id: this.selectedAccountsDetails?.account?.account_id,
          label_accounts: label_accounts || []
        });
      }
    },
    onCheckBox: function(e, item) {
      const value = e.target.checked ? "1" : "0";
      this.$emit("changed", {
        name: "exclude",
        value,
        kVal: item.label_account_id,
        table: "l_label_accounts"
      });
      this.updateData(item);
    },

    updateData: function(item) {
      const label_accounts = this.selectedAccountsDetails.label_accounts.map(
        b => {
          if (b.label_account_id === item.label_account_id) {
            b = {
              ...item
            };
          }
          return b;
        }
      );

      this[ActionTypes.DistributionCatalogueLabels.SET.ALL]({
        account_id: this.selectedAccountsDetails?.account?.account_id,
        label_accounts: label_accounts || []
      });
    }
  }
};
</script>

<style lang="scss">
.cmp-distribution-accounts-account_sidewindow-catalogue_labels_list {
  .fc2 {
    border-bottom: none !important;
  }
}
</style>
